/** Which plans staff cut a given feature — KLUB-173. */

export interface PlanCutRow {
  name: string;
  config: Record<string, unknown> | null;
}

export function planNamesThatCut(plans: readonly PlanCutRow[], key: string): string[] {
  return plans
    .filter((plan) => plan.config?.[key] === false)
    .map((plan) => plan.name);
}

export function cutCaption(names: readonly string[]): string | null {
  if (names.length === 0) return null;
  return `Cortado em: ${names.join(", ")}`;
}
